import CareProgramVasIcon from '../../../../assets/vas/careProgrampdpdrawer.svg';
import FlexiCancellation from '../../../../assets/vas/FlexiCancellation.svg';
import AssuredSellbackIcon from '../../../../assets/vas/AssuredSellback.svg';
import GrayArrowWithWhiteBg from '@/assets/arrows/GrayArrowWithWhiteBg.svg';
import Stars from './stars';
import { Box, Button, Drawer } from '@mui/material';
import { LencoTypography } from '@/atomic-components/LencoTypography';
import { getColor } from '@/utils/theme/colors';
import FlexBox from '@/atomic-components/FlexBox';
import { getStyle } from '@/utils/theme/fonts';
import { useState } from 'react';
import LencoButton from '@/atomic-components/LencoButton';
import VasDrawer, { VasNames } from './vasDrawer';
import React from 'react';

export type VASInformation = {
	description: string;
	name: string;
	startingAtText: string;
	termsAndConditions: string;
	type: string;
};
export type IVASTileProps = {
	vas: VASInformation[];
};

export type ProgramProps = {
	background: string;
	icon: any;
	starColor: string;
};

export type VAStileMapper = {
	FURLENCO_CARE_PROGRAM: ProgramProps;
	AssuredSellbackVas: ProgramProps;
	other: ProgramProps;
};

export const VASMapper = {
	FURLENCO_CARE_PROGRAM: {
		background: 'linear-gradient(0deg, #B4E1E5 0%, #CEEDF0 100%)',
		icon: <CareProgramVasIcon />,
		starColor: 'Minty -5',
	},
	AssuredSellbackVas: {
		background: 'linear-gradient(180deg, #DDE3F9 0%, #BDC7F4 100%)',
		icon: <AssuredSellbackIcon />,
		starColor: 'Navy -5',
	},
	FLEXI_CANCELLATION: {
		background: 'linear-gradient(180deg, #FEEAD2 0%, #FDCFA6 100%)',
		icon: <FlexiCancellation />,
		starColor: 'Orange -5',
	},
	other: {
		background: 'linear-gradient(180deg, #FEEAD2 0%, #FDCFA6 100%)',
		icon: <></>,
		starColor: 'Orange -5',
	},
};

const VASComponent = (props: IVASTileProps) => {
	const [tncopen, setTncOpen] = useState(false);
	const [vasIndex, setVasIndex] = useState<number>();

	const handleVasDrawerAction = (index: number) => {
		setVasIndex(index);
		setTncOpen(true);
	};

	return (
		<FlexBox direction='column'>
			<LencoTypography
				sx={{ ...getStyle('Small_Medium'), color: getColor('Gray -2') }}
			>
				GET MORE WITH
			</LencoTypography>
			<LencoTypography
				sx={{
					...getStyle('H10A_Medium'),
					color: getColor('Gray 0'),
					paddingBottom: '24px',
				}}
			>
				Value added Services
			</LencoTypography>
			{props?.vas?.map((vas, index) => {
				const VasTileStyle = VASMapper[vas.type as keyof VAStileMapper] || VASMapper['other']
				return (
					<Box
						key={index}
						sx={{
							paddingBottom: '8px',
							position: 'relative',
							overflow: 'hidden',
						}}
					>
						<FlexBox
							sx={{
								background: `${VasTileStyle.background}`,
								borderRadius: '32px',
								padding: '32px',
								justifyContent: 'space-between',
								gap: 2,
								position: 'relative',
								overflow: 'hidden',
								cursor: 'pointer',
								'&:hover': {
									// background:
									// 'linear-gradient(0deg, #CEEDF0 0%, #B4E1E5 100%);',
									transition: '10s background ease-in-out',
									'#stars': {
										top: 80,
										transform: 'rotateZ(270deg)',
										transitionTimingFunction: 'linear',
										transition:
											'0.5s top ease-in-out, 0.5s transform ease-in-out',
									},
									// border: `1px solid ${getColor('Minty +1')}`,
								},
							}}
							onClick={() => setTncOpen(!tncopen)}
						>
							<Box id='stars' sx={{ position: 'absolute', left: 6, top: 0 }}>
								<Stars color={getColor(`${VasTileStyle.starColor}`)} />
							</Box>
							<Box>{VasTileStyle.icon}</Box>
							<Box sx={{ textAlign: 'left', width: '100%' }}>
								<LencoTypography
									sx={{
										...getStyle('H9A_Medium'),
										fontStyle: 'italic',
										color: getColor('Gray 0'),
									}}
								>
									{VasNames[vas?.type as keyof typeof VasNames] || vas?.name}
								</LencoTypography>
								<LencoTypography
									sx={{
										...getStyle('Small_Medium'),
										color: getColor('Gray -1'),
									}}
								>
									{vas?.startingAtText}
								</LencoTypography>
								<FlexBox
									sx={{ justifyContent: 'space-between', alignItems: 'end' }}
								>
									<LencoTypography
										sx={{
											...getStyle('Small_Regular'),
											color: getColor('Gray -2'),
										}}
										componentUsage='PARAGRAPH'
										dangerouslySetInnerHTML={{
											__html: vas.description,
										}}
									></LencoTypography>
									<Box>
										<GrayArrowWithWhiteBg />
									</Box>
								</FlexBox>
							</Box>
						</FlexBox>
						<VasDrawer
							vas={vas}
							open={tncopen}
							closeDrawer={() => {
								setTncOpen(false);
							}}
						/>
					</Box>
				);
			})}
		</FlexBox>
	);
};

export default VASComponent;
